import React from "react";
import { ActionsMenu } from "../../common/components/ActionsMenu";
import { ConditionalWrapper } from "../../common/components/ConditionalWrapper";
import { MENU_FILTERS } from "../../common/components/modals/constants";
import useModal from "../../common/components/modals/useModal";
import { useAccessWindowSize } from "../../common/layout/useAccessWindowSize";
import { USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV } from "../../common/roles/constants";
import useRolesVisibility from "../../common/roles/useRolesVisibility";
import { RequiredRoles } from "../../search/criteria/components/common/requiredRoles";
import { SearchResultsPreviewContainer } from "../../search/preview/SearchResultsPreviewContainer";
import useSearch from "../../search/result/useSearch";
import { Searches } from "../../search/searches/Searches";
import useSearchState from "../../search/useSearchState";
import { getAllCriteria } from "../../search/utils";
import { useLocalNewsType } from "../useLocalNewsType";
import { criteriaGroupsType } from "../../common/types/search/search";

interface CriteriaProps {
	criteria: criteriaGroupsType;
	namespace: string;
	searchesEnabled: boolean;
}

export function Criteria({
	criteria,
	namespace,
	searchesEnabled,
}: CriteriaProps) {
	const { onSearch, onClearSearch, onClearInput } = useSearch();
	const { hashDataExists } = useSearchState([""]);
	const { hasOneOfRequiredRoles } = useRolesVisibility(
		RequiredRoles.showFor([USER_ROLE_NEWS, USER_ROLE_NEWS_BIZAV]),
	);
	const { isMobile } = useAccessWindowSize();
	const { clearModals } = useModal();
	const { clearLocalType } = useLocalNewsType();

	const handleClearSearch = (e) => {
		clearLocalType();
		hashDataExists ? onClearSearch(e) : onClearInput(e);
	};

	if (!hasOneOfRequiredRoles) {
		return null;
	}

	return (
		<ConditionalWrapper
			condition={isMobile}
			wrapper={(children) => (
				<ActionsMenu
					id={MENU_FILTERS}
					onClose={clearModals}
					title="Filter news"
				>
					{children}
				</ActionsMenu>
			)}
		>
			<section className="search-results-criteria">
				{getAllCriteria(criteria).map((component, key) => (
					<React.Fragment key={key}>{component}</React.Fragment>
				))}
			</section>

			<SearchResultsPreviewContainer label={"news items"} />

			<section className="search-results-actions">
				<div className="searches-actions">
					{searchesEnabled && (
						<Searches
							namespace={namespace}
							label="Current search"
						/>
					)}
				</div>

				<div className="btn-group">
					<button
						type="button"
						className="btn btn--primary"
						onClick={onSearch}
					>
						Apply filters
					</button>
					<button
						type="button"
						className="btn btn--secondary btn--clear"
						onClick={handleClearSearch}
					>
						Clear search
					</button>
				</div>
			</section>
		</ConditionalWrapper>
	);
}
